import { useEffect, useRef } from 'react'

export const useHideBodyScroll = (hide: boolean, options?: { restorePosition?: boolean }) => {
  const scrollPosition = useRef(0)
  useEffect(() => {
    if (!hide) {
      document.body.style.overflow = 'auto'
      document.body.style.height = 'auto'
      document.body.style.width = 'auto'
      document.body.style.position = 'static'
      if (options?.restorePosition) {
        window.scrollTo({ top: scrollPosition.current })
      }
    } else {
      scrollPosition.current = window.scrollY
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100%'
      document.body.style.width = '100%'
      document.body.style.position = 'fixed'
    }
  }, [hide, scrollPosition, options?.restorePosition])
}
